/**
 * Single formatter for a ticket's display identifier (design doc "Ticket
 * references", 2026-08-24): the Linear-style `ref` (e.g. "CXG-512") when the
 * ticket has one, else the short id — the same fallback every server-side
 * display site (email subject, copy payload, presentation payload) uses.
 * Kept in one place so the list, detail headers and deck cards can't drift
 * on the fallback format.
 *
 * `shortId`, when the caller already has one (e.g. TrackerPresentationEntry,
 * which carries a server-computed `shortId` field), is preferred over
 * re-deriving it from `_id` — same value in practice, but avoids the client
 * quietly re-implementing the server's slicing convention.
 */
export function formatTicketRef(entity: { ref?: string | null; _id: string; shortId?: string }): string {
  if (entity.ref) return entity.ref
  return `#${(entity.shortId ?? entity._id.slice(-6)).toUpperCase()}`
}
